import { Component, OnInit } from '@angular/core';
import { CommonDataService } from 'src/app/common/services/common-data.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent implements OnInit {

  constructor(
    public commonDataService : CommonDataService
  ) { }

  ngOnInit(): void {
 
    this.commonDataService.closeModalOption.next(true);
  }

  openPopup(){
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightOverlayOption.next("Terms And Conditions");
    this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    this.commonDataService.closeModalOption.next(false);
  }
}
